export const ADD = 'add';
export const EDIT = 'edit';
export const DELETE = 'delete';
export const VIEW = 'view';
export const COPY = 'copy';
export const DUPLICATE = 'duplicate';
export const PRINT = 'print';
export const UPLOAD_DOWNLOAD = 'uploadDownload';
